import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  const navLinks = [
    { label: 'Home', id: 'hero' },
    { label: 'About', id: 'about' },
    { label: 'AI Voice Agents', id: 'ai-voice' },
    { label: 'Experience', id: 'experience' },
    { label: 'Services', id: 'services' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="w-full px-6 lg:px-12 py-3 flex items-center justify-between">
        {/* Logo */}
        <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('hero'); }} className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/b0d28b98390413eddff47342c2e73859/20aa6e2d8ba050ef68f0ff711571da9e.png"
            alt="GITS Logo"
            className="h-10 w-auto object-contain"
          />
          <span className={`font-bold text-sm leading-tight hidden lg:block transition-colors duration-300 ${scrolled ? 'text-gray-800' : 'text-white'}`}>
            GITS - Global Innovation Technology Solutions
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className={`px-3 py-2 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-teal-600 hover:bg-teal-50' : 'text-white/90 hover:text-white hover:bg-white/10'}`}
            >
              {link.label}
            </button>
          ))}
          <a
            href="https://jessica.readdy.co"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-2 px-4 py-2 bg-teal-500 text-white text-sm font-semibold rounded-full hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Jessica
          </a>
          <a
            href="https://betty.readdy.co"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-1 px-4 py-2 bg-amber-500 text-white text-sm font-semibold rounded-full hover:bg-amber-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Betty
          </a>
          <a
            href="https://stephanie.petergits.com"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-1 px-4 py-2 bg-rose-500 text-white text-sm font-semibold rounded-full hover:bg-rose-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Stephanie
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${scrolled ? 'text-gray-800' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white shadow-lg border-t border-gray-100 px-6 py-4">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="block w-full text-left px-3 py-3 text-sm font-medium text-gray-700 hover:text-teal-600 hover:bg-teal-50 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <a
            href="https://jessica.readdy.co"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 block w-full text-center px-4 py-2 bg-teal-500 text-white text-sm font-semibold rounded-full hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Jessica
          </a>
          <a
            href="https://betty.readdy.co"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 block w-full text-center px-4 py-2 bg-amber-500 text-white text-sm font-semibold rounded-full hover:bg-amber-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Betty
          </a>
          <a
            href="https://stephanie.petergits.com"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 block w-full text-center px-4 py-2 bg-rose-500 text-white text-sm font-semibold rounded-full hover:bg-rose-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Stephanie
          </a>
        </div>
      )}
    </nav>
  );
}
